import React, { useState } from 'react';

import { ApiInstructionContent } from './components/ApiInstructionContent';
import { FaqContent } from './components/FaqContent';
import { InstructionTabs } from './components/InstructionTabs';
import { InterfaceInstructionContent } from './components/InterfaceInstructionContent';
import { instructionTabs } from './content/tabs';
import { InstructionTab } from './types';

export const Instruction: React.FC = () => {
  const [activeTab, setActiveTab] = useState<InstructionTab>(InstructionTab.Interface);

  return (
    <div className="instruction">
      <div className="instruction__title">Правила подачи и обработки сигналов автором стратегии</div>
      <InstructionTabs activeTab={activeTab} tabs={instructionTabs} onChange={setActiveTab} />
      {activeTab === InstructionTab.Interface && <InterfaceInstructionContent />}
      {activeTab === InstructionTab.Api && <ApiInstructionContent />}
      {activeTab === InstructionTab.Faq && <FaqContent />}
    </div>
  );
};
